import React from 'react';
import OrderMovil from 'components/Tvendo/Sale/Operations/OrderWebMovil/OrderWebMovil.js';
import { ConstantPermissions } from 'contexts/useConstant';

export default function () {
  return (
    <OrderMovil
      type="M"
      title="retenidos móvil"
      permission={{
        show: ConstantPermissions.ORDM_ORDERS_SHOW,
        store: '',
        annular: ConstantPermissions.ORDM_ORDERS_ANNULAR_RETAINED_ORDER,
        approve: ConstantPermissions.ORDM_ORDERS_APPROVE_RETAINED_ORDER,
        ruleIndex: ConstantPermissions.LOGI_RULE_DISCOUNTS_INDEX,
        ruleShow: ConstantPermissions.LOGI_RULE_DISCOUNTS_SHOW,
      }}
    />
  );
}
